import { render, staticRenderFns } from "./ProductScrollList.vue?vue&type=template&id=8e9f719e&scoped=true"
import script from "./ProductScrollList.vue?vue&type=script&lang=js"
export * from "./ProductScrollList.vue?vue&type=script&lang=js"
import style0 from "./ProductScrollList.vue?vue&type=style&index=0&id=8e9f719e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9f719e",
  null
  
)

export default component.exports